export default "__VITE_ASSET__5a4f6765__"